import '../styles/loading.css'
import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

class LoadingComponent extends React.Component {

    render = () => {
        
            return (
                <div className="loading">
                    <h4>Just a moment ...</h4>

                    <div className="loading-spinner-2 fade-in">
                        <FontAwesomeIcon icon={faSpinner} className="close-icon animate-spin" />
                    </div>


                    { /*<div className="loading-spinner fade-in">
                        <div className="loading-spinner-particle"></div>
                        <div className="loading-spinner-particle particle-2"></div>
                        <div className="loading-spinner-particle particle-3"></div>
                        <div className="loading-spinner-particle particle-4"></div>
                        <div className="loading-spinner-particle particle-5"></div>
                        <div className="loading-spinner-particle particle-6"></div>
                        <div className="loading-spinner-particle particle-7"></div>
                        <div className="loading-spinner-particle particle-8"></div>
                    </div> */
                }
                </div>
            );
        
    }
}

export default LoadingComponent;